var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isLogin
    ? _c(
        "div",
        {
          attrs: { id: "header-omc-wrapper" },
          on: {
            click: function ($event) {
              _vm.isMobile ? _vm.$router.push({ name: "MyPage" }) : null
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c("Roller", {
                staticClass: "header-omc",
                attrs: {
                  text: _vm.totalToken[0],
                  "is-number-format": "",
                  transition: 0.5,
                },
              }),
              _c("span", [_vm._v(".")]),
              _c("Roller", {
                staticClass: "header-omc decimal",
                attrs: { text: _vm.totalToken[1], transition: 0.5 },
              }),
            ],
            1
          ),
          _c("img", {
            staticClass: "symbol",
            attrs: { src: `${_vm.$s3}/img/common/omc.webp?${_vm.$ver}` },
          }),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }